import 'buefy/dist/buefy.css'
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';
import "babel-polyfill";
import "isomorphic-fetch";
import Vue from 'vue';
import Buefy from 'buefy';
import VueMaterial from 'vue-material';
import Vuelidate from 'vuelidate';
import AutoRotate from 'vue-jpeg-auto-rotation';
import './assets/app.scss';
import App from './App.vue';

import CallingApi from './components/CallingApi.vue';
import DatePicker from './components/DatePicker.vue';
import AutocompleteMasterDataSelect from './components/AutocompleteMasterDataSelect.vue';
import AutocompleteFSIDriverMasterSelect from './components/AutocompleteFSIDriverMasterSelect.vue';
import AutocompleteMasterDataMultipleSelect from './components/AutocompleteMasterDataMultipleSelect.vue';
import AutocompleteSearchableStoreMultipleSelect from './components/AutocompleteSearchableStoreMultipleSelect.vue';
import DriverGroupSelect from './components/DriverGroupSelect.vue';
import AutoCompleteSelect from './components/AutoCompleteSelect.vue';
import MasterDataDisplay from './components/MasterDataDisplay.vue';
import MasterDataSelect from './components/MasterDataSelect.vue';
import Sort from './components/Sort.vue';
import ViewImage from './components/ViewImage.vue';
import Pagination from './components/Pagination.vue';
import PaginationNew from './components/PaginationNew.vue';
import DownloadPicturesButton from './components/DownloadPicturesButton.vue';

import router from './router';
import store from './store';
import _ from './utils/underscore';
import dateFormat from './utils/dateFormat';
import numberFormat from './utils/numberFormat';
import { updateTableHeight } from './utils/dataTable';
import directiveDebounce from './utils/directive-debounce'


import Config from './config.js';
//import api from './api';
import { newAPIPost } from './api/index.js';
import string from './string';

console.log(`env=${Config.env}`);

var idleTime = 0
// if (Config.env == "qas" || Config.env == "prd")
// {
  window.onfocus = function(){ idleTime = 0 }
  window.onclick = function(){ idleTime = 0 }

  var frequency = setInterval(function(){
    idleTime++
    // console.log("Idle time: ", idleTime)
    //time is in millisecond, do below exec every 1 sec
    //then if idle 30 mins - now updated to 4 hours logout
    //if (idleTime > 1800 ){
    if ( idleTime > 28800 ) {
      clearInterval(frequency)
      store.dispatch('logout');
      return;
    }
  },1000)
// }

window.Promise = Promise; // fix for IE and of course I HATE IE!

// eslint-disable-next-line import/no-extraneous-dependencies
window._ = _;
window.moment = require('moment-timezone');

// moment.tz.setDefault('America/Los_Angeles');
window.$ = require('jquery');
window.Vue = Vue;

Vue.use(Vuelidate);
Vue.use(Buefy);
Vue.use(VueMaterial);
Vue.use(AutoRotate);
Vue.config.productionTip = false;
Vue.component('sort', Sort);
Vue.component('calling-api', CallingApi);
Vue.component('view-image', ViewImage);
Vue.component('download-pictures-button', DownloadPicturesButton);
Vue.component('datepicker', DatePicker);
Vue.component('pagination', Pagination);
Vue.component('paginationNew', PaginationNew);
Vue.component('master-data-display', MasterDataDisplay);
Vue.component('master-data-select', MasterDataSelect);
Vue.component('driver-group-select', DriverGroupSelect);
Vue.component('auto-complete-select', AutoCompleteSelect);
Vue.component('auto-complete-master-data-select', AutocompleteMasterDataSelect);
Vue.component('auto-complete-master-data-multiple-select', AutocompleteMasterDataMultipleSelect);
Vue.component('auto-complete-search-store-multiple-select', AutocompleteSearchableStoreMultipleSelect);
Vue.component('auto-complete-f-s-i-driver-master-select', AutocompleteFSIDriverMasterSelect);
Vue.directive('debounce', directiveDebounce); 


//Vue.prototype.$material.locale.dateFormat = 'M/D/YYYY'; //for dev,qas, and prd
Vue.prototype.$material.locale.dateFormat = 'MM/dd/yyyy'; //for local testing

Vue.mixin({
  watch: {
    // checkVersion:
    // {
    //   deep: true,
    //   handler(){
    //     this.checkUserProfile();
    //   }
    // },
    searchRequest: {
      deep: true,
      handler() {
        console.log(`handler`);
        this.updateTableHeight();
        this.checkUserProfile();
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$el && this.$el.querySelector && this.$el.querySelector('.data-table-container')) {
        window.addEventListener('resize', this.updateTableHeight);
        this.updateTableHeight();
        this.intervalId = setInterval(() => {
          this.updateTableHeight()
        }, 1000);
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableHeight);
    clearInterval(this.intervalId);
  },
  methods: {
    updateTableHeight() {
      updateTableHeight(this);
    },

    checkUserProfile() {
      //api.post("/api/w/users/me", {
      newAPIPost("/api/w/users/me", {
        appName: string.appName,
        ver: string.ver,
      }).catch((err) => {
        if (err.debugCode == 409)
        {
          window.confirm(err.debugCode + ' Outdate Web Version. Must Refresh Webpage!');
          window.location.reload();         
          return;
        }
        if (err.debugCode == 401)
        {
          window.confirm(err.debugCode + ' User is inactived!');
          this.$store.dispatch('logout', true);     
          return;
        }
      });
    },
  },
})






_(dateFormat).each((fn, key) => {
  Vue.filter(key, fn);
});

_(numberFormat).each((fn, key) => {
  Vue.filter(key, fn);
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
